import { DataTable } from './DataTable'
import { Button, message } from 'antd'
import { YhBox } from '@/components/YhBox'
import { baseMaintenanceTechnicianModel } from '../maintenanceTechnicianModel'
import { UserDeleteOutlined, UserAddOutlined } from '@ant-design/icons'

export const DataBox = () => {
    const { setAddCarVisible, onDelete, selectedRowKeys } = baseMaintenanceTechnicianModel()

    const action = (
        <>
            <Button shape="round" type="primary" onClick={() => setAddCarVisible(true)}>
                <UserAddOutlined />
                添加维修技师
            </Button>
            <Button
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        return message.warning('请选择维修技师进行删除功能！')
                    } else {
                        onDelete(selectedRowKeys)
                    }
                }}
            >
                <UserDeleteOutlined />
                一键删除
            </Button>
        </>
    )

    return (
        <div>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)' }}>
                <DataTable />
            </YhBox>
        </div>
    )
}
